/*
 * blog-loadmore.js — „Načíst další články" přidává dávku, nestránkuje (bod Y).
 *
 * NÁLEZ MAJITELE (19. 9. 2026, doslova): „Když v blogu kliknu na ‚Načíst
 * další' měly by se aditivně zobrazit další články, teď to funguje jak
 * stránkování a to je špatně. má to načítat další, a mám mít možnost si
 * vyrolovat nahoru až k nejnovějším článkům."
 *
 * PŘÍČINA: tlačítko bylo (a zůstává) `<a href="/…/page/N/">`. Klik spustil
 * plnou navigaci, prohlížeč vykreslil NOVÝ dokument s dalšími šesti
 * dlaždicemi a první dávka zmizela — vyrolovat nahoru k nejnovějším
 * článkům tedy nešlo.
 *
 * ---------------------------------------------------------------------
 * VZOR JE Z TERRAHUNTU, SE DVĚMA VĚDOMÝMI ODCHYLKAMI
 * ---------------------------------------------------------------------
 * Předloha: `terrahunt-2026/assets/js/src/blog-loadmore.js`. Přebírá se
 * z ní celý postup (fetch další strany → `DOMParser` → vytáhnout jen
 * karty → `appendChild` → řetězení adresy z tlačítka v odpovědi →
 * `focus({ preventScroll: true })` → fail-open na plnou navigaci).
 *
 * 1. ADRESA SE NEMĚNÍ. TerraHunt volá `history.replaceState` a posouvá
 *    adresu na `/page/N`. Tady by to ale rozbilo právě to, co majitel
 *    žádá: po obnovení stránky by se vykreslila JEN poslední dávka
 *    a vyrolovat nahoru k nejnovějším článkům by zase nešlo. Adresa
 *    proto zůstává na první straně a obnovení vrátí výpis od začátku.
 *
 * 2. SPOUŠTĚČ JE `<a>`, NE `<button>`. Bez JavaScriptu musí zůstat
 *    průchozí odkaz na `/…/page/N` (SEO kontrakt stránkování, page
 *    cache). `disabled` na odkazu neexistuje, takže se dvojklik hlídá
 *    příznakem a `aria-disabled`.
 *
 * ---------------------------------------------------------------------
 * PROČ FETCH CELÉ STRÁNKY A PROČ JEN `.btile`
 * ---------------------------------------------------------------------
 * Další dávku už server umí vykreslit sám na `/…/page/N` — vlastní REST
 * endpoint by byl druhá cesta k témuž obsahu, tedy druhé místo, které se
 * musí udržovat. Z odpovědi se berou JEN dlaždice (`#za-bgrid .btile`),
 * ne celý obsah mřížky: kdyby se připojoval celý `innerHTML`, přišly by
 * s ním i prvky, které se na stránce opakovat nemají.
 *
 * Adresa další dávky se čte z tlačítka V ODPOVĚDI, ne z čísla strany
 * dopočítaného v prohlížeči. Server tím drží stav řetězu (včetně
 * přenesených filtrů `?category=` a `?author=`, viz hlavička
 * `listing-post.php`) a skript o stránkování neví nic.
 *
 * MIMO VÝPIS BLOGU NEDĚLÁ NIC — bez `[data-loadmore]` se vrátí dřív,
 * než zaregistruje posluchače.
 */

export function init() {
	const spoustec = document.querySelector( '[data-loadmore]' );
	if ( ! spoustec ) {
		return 0;
	}

	const mrizka = document.getElementById( 'za-bgrid' );
	if ( ! mrizka ) {
		return 0;
	}

	const hlaska = document.querySelector( '[data-loadmore-status]' );
	let bezi = false;

	spoustec.addEventListener( 'click', ( e ) => {
		const adresa = spoustec.getAttribute( 'href' ) || '';
		if ( '' === adresa || bezi ) {
			return;
		}
		/*
		 * `preventDefault` až TADY, ne na začátku: když adresa chybí nebo
		 * už jedna dávka běží, ať se odkaz chová jako odkaz. Mrtvé tlačítko
		 * je horší než skok na další stranu.
		 */
		e.preventDefault();
		bezi = true;
		spoustec.setAttribute( 'aria-disabled', 'true' );

		fetch( adresa, { credentials: 'same-origin' } )
			.then( ( r ) => {
				if ( ! r.ok ) {
					throw new Error( 'blog-loadmore: HTTP ' + r.status );
				}
				return r.text();
			} )
			.then( ( html ) => {
				const doc = new DOMParser().parseFromString( html, 'text/html' );
				const nove = [ ...doc.querySelectorAll( '#za-bgrid .btile' ) ];
				if ( ! nove.length ) {
					bezi = false;
					spoustec.removeAttribute( 'aria-disabled' );
					return;
				}

				const pocetPred = mrizka.querySelectorAll( '.btile' ).length;
				const kus = document.createDocumentFragment();
				for ( const karta of nove ) {
					kus.appendChild( document.importNode( karta, true ) );
				}
				/*
				 * `appendChild` na živou mřížku, ŽÁDNÝ `innerHTML` —
				 * stávající dlaždice zůstanou netknuté a scroll se nehne.
				 */
				mrizka.appendChild( kus );

				const dalsi = doc.querySelector( '[data-loadmore]' );
				const dalsiAdresa = dalsi ? dalsi.getAttribute( 'href' ) || '' : '';
				if ( '' !== dalsiAdresa ) {
					spoustec.setAttribute( 'href', dalsiAdresa );
					spoustec.removeAttribute( 'aria-disabled' );
				} else {
					/* Poslední dávka: tlačítko nemá kam vést, zmizí celé. */
					const obal = spoustec.closest( '.bmore' );
					if ( obal ) {
						obal.hidden = true;
					}
				}

				/*
				 * Fokus na první NOVOU dlaždici, ale `preventScroll` —
				 * jinak by prohlížeč posunul výřez a majitel by zase
				 * nebyl tam, kde byl. Pro klávesnici je to jediný způsob,
				 * jak se k přírůstku dostat bez projití celého seznamu.
				 */
				const vsechny = mrizka.querySelectorAll( '.btile' );
				const prvniNova = vsechny[ pocetPred ];
				const cil = prvniNova ? prvniNova.querySelector( 'a' ) : null;
				if ( cil && 'function' === typeof cil.focus ) {
					cil.focus( { preventScroll: true } );
				}

				if ( hlaska ) {
					const sablona = spoustec.getAttribute( 'data-announce' ) || '';
					hlaska.textContent = sablona ? sablona.replace( '%d', String( nove.length ) ) : '';
				}

				bezi = false;
			} )
			.catch( () => {
				/*
				 * Fail-open: síť nebo 5xx. `href` pořád míří na skutečnou
				 * stránku výpisu, takže se degraduje na PŮVODNÍ chování
				 * (skokové, ale funkční), ne na mrtvé tlačítko.
				 */
				bezi = false;
				spoustec.removeAttribute( 'aria-disabled' );
				window.location.href = adresa;
			} );
	} );

	return 1;
}
